import VueModal from 'vue-js-modal';

import dialogComponent from './components/dialog.vue';

const vueModalOptions = {
  adaptive: true,
  clickToClose: false,
  height: 'auto',
  maxWidth: 360
};

const Dialog = {
  install: function(Vue) {
    // Dialogが既にinstalledな場合は実行させない
    if (this.installed) {
      return;
    }

    this.installed = true;

    // VueModalが既にinstalledな場合は実行されない
    VueModal.install(Vue, {
      dynamic: true,
      injectModalsContainer: true
    });

    Vue.prototype.$alert = (message, options) => {
      return new Promise((resolve) => {
        Vue.prototype.$modal.show(
          dialogComponent, {
            type: 'alert',
            message: message,
            options: options,
            confirmCallback() {
              resolve();
            }
          },
          vueModalOptions
        );
      });
    };

    Vue.prototype.$confirm = (message, options) => {
      return new Promise((resolve, reject) => {
        Vue.prototype.$modal.show(
          dialogComponent, {
            type: 'confirm',
            message: message,
            options: options,
            cancelCallback() {
              reject();
            },
            confirmCallback() {
              resolve();
            }
          },
          vueModalOptions
        );
      });
    };
  }
};

export default Dialog;
